"use client"

import { env } from "~/env"
import clsx from "clsx"

import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import { useLocale } from "~/lib/i18n/hooks/useLocale"
import { getReferenceIdFromGID } from "~/lib/shopify/utils/id"
import { useYotpoRefresh } from "~/hooks/useYotpoRefresh"
import { hrefResolver } from "~/components/ui/Link/utils/href-resolver"
import getAlternateUrl from "~/utils/alternate-url"

import * as css from "./styles.css"

export interface YotpoReviewsProps {
  product: UnlikelyProduct
}

export default function YotpoReviews({ product }: YotpoReviewsProps) {
  useYotpoRefresh()

  const locale = useLocale()
  const productUrl =
    product?.id && product?.handle && locale ? hrefResolver({ id: product.id, handle: product.handle }, locale) : null

  return (
    <div className={css.YotpoReviewsContainer}>
      <div
        className={clsx("yotpo-widget-instance", css.YotpoReviews)}
        data-yotpo-instance-id={env.NEXT_PUBLIC_REVIEWS_YOTPO_WIGDET_INSTANCE_ID}
        data-yotpo-product-id={getReferenceIdFromGID(product?.id)}
        data-yotpo-name={product.title}
        data-yotpo-url={productUrl && getAlternateUrl(productUrl)}
        data-yotpo-image-url={product?.featuredImage?.url}
        data-yotpo-price={product.priceRange?.minVariantPrice?.amount}
        data-yotpo-currency={product.priceRange?.minVariantPrice?.currencyCode}
        data-yotpo-description={product?.description}
      ></div>
    </div>
  )
}
